import type { IMosaicTocExpanded } from "./interface";

/**
 * Shows the refresh-required alert.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with the refresh alert visible.
 */
export const toc_showTocNeedRefresh = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  showNeedRefresh: true,
});
